export default __webpack_public_path__ + "static/media/Statement1.44252d88.svg";